import React from 'react';
import PropTypes from 'prop-types';

export const DemographicsList = ({ show, male, female, total }) => {
    if (!show || isNaN(male) || isNaN(female)) {
        return <></>;
    }

    /**
     * @see https://stackoverflow.com/a/32072414
     */
    const thousandSeparatorRegex = new RegExp(/\B(?=(\d{3})+(?!\d))/g);
    return (
        <ul className="map-menu--demographics">
            <li>
                Total workers:
                {' ' + total.toString().replace(thousandSeparatorRegex, ',')}
            </li>
            <li>Male workers: {male.toString().replace(thousandSeparatorRegex, ',')} </li>
            <li>Female workers: {female.toString().replace(thousandSeparatorRegex, ',')}</li>
        </ul>
    );
};

DemographicsList.props = {
    show: PropTypes.bool,
    male: PropTypes.number,
    female: PropTypes.number,
    total: PropTypes.number,
};
